import { render } from "./TabAcademic.vue?vue&type=template&id=634f5a21&ts=true"
import script from "./TabAcademic.vue?vue&type=script&lang=ts"
export * from "./TabAcademic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__